export default __webpack_public_path__ + "static/digi-banner-11a6c1b4283613d05ab3681463aa5a58.webp";